import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, throwError, Subject } from 'rxjs';
import { distinctUntilChanged, retry, catchError } from 'rxjs/operators';

import { SCREEN_SIZE, ResolutionsViewResults } from '../Models/common.model';


@Injectable({
    providedIn: 'root'
})

export class ResolutionViewService {
    private apiURL = window.location.href.split('?')[0];
    private queryParams = (window.location.href.split('?').length > 1) ? window.location.href.split('?')[1] : "";
    private resolutionApi = window.location.origin;

    get onResize$(): Observable<SCREEN_SIZE> {
        return this.resizeSubject.asObservable().pipe(distinctUntilChanged());
    }

    private resizeSubject: Subject<SCREEN_SIZE>;

    onResize(size: SCREEN_SIZE) {
        this.resizeSubject.next(size);
    }

    constructor(private http: HttpClient) {
        this.resizeSubject = new Subject();
    }
    httpOptions = {
        headers: new HttpHeaders({
            'Content-Type': 'application/json'
        })
    }

    getResolutionGridDetails(keyword, statuses, startDate, endDate, id): Observable<ResolutionsViewResults[]> {
        var queryParameters = "";
        if (keyword != null)
            queryParameters += 'keyword=' + keyword + '&';
        if (statuses != null)
            queryParameters += 'statuses=' + statuses + '&';
        if (startDate != null)
            queryParameters += 'startdate=' + startDate + '&';
        if (endDate != null)
            queryParameters += 'enddate=' + endDate + '&';
        if (id != null)
            queryParameters += 'resolutionId=' + id + '&';
        queryParameters = queryParameters.substr(0, queryParameters.length - 1);
        var url = this.resolutionApi + '/Api/SwapaApi/GetClosedResolutions?' + queryParameters;
        return this.http.get<ResolutionsViewResults[]>(this.resolutionApi + '/Api/SwapaApi/GetClosedResolutions?' + queryParameters)
            .pipe(
                retry(1),
                catchError(this.handleError)
            )
    }

    handleError(error) {
        let errorMessage = '';
        if (error.error instanceof ErrorEvent) {
            // Get client-side error
            errorMessage = error.error.message;
        } else {
            // Get server-side error
            errorMessage = `Error Code: ${error.status}\nMessage: ${error.message}`;
        }
        console.log(errorMessage);
        return throwError(errorMessage);
    }
}
